const config = {
  dataWorldApiToken: process.env.REACT_APP_DATA_WORLD_API_TOKEN,
  owner: process.env.REACT_APP_DATA_WORLD_OWNER,
  datasetId: process.env.REACT_APP_DATA_WORLD_DATASET_ID,
};

export default config;
